import { render, staticRenderFns } from "./PersonPreview.vue?vue&type=template&id=efade6fc&scoped=true&"
import script from "./PersonPreview.vue?vue&type=script&lang=js&"
export * from "./PersonPreview.vue?vue&type=script&lang=js&"
import style0 from "./PersonPreview.vue?vue&type=style&index=0&id=efade6fc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efade6fc",
  null
  
)

export default component.exports